import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { appSettings } from '@app/core/constants/appSettings';
import { regEx } from '@app/core/constants/regEx';
import { validationMsgs } from '@app/core/constants/validationMsgs';
import { DataService } from '@app/core/services/data.service';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { delay, map, of } from 'rxjs';
import { ApplicationFormDataService } from '../application-form/application-form-data.service';
import { ApplicationFormService } from '../application-form/application-form.service';

@Injectable({
   providedIn: 'root',
})
export class JointApplicantService {
   referenceData = this.afs.getRefDataModel();
   subscription = this.afs.subscribeRefDataModel((data: any) => {
      this.referenceData = data;
   });

   constructor(
      private afs: ApplicationFormService,
      private dataService: DataService,
      private afds: ApplicationFormDataService
   ) {
      console.log('ja refdata ' + JSON.stringify(this.referenceData));
   }

   yesNoMap = [
      {
         value: false,
         name: 'No',
      },
      {
         value: true,
         name: 'Yes',
      },
   ];

   cachedNiNumber: null | string = null;

   public setCachedNiNumber(niNumber: string) {
      this.cachedNiNumber = niNumber;
   }

   fetchForm(globalValidators: any, changeFns: any): any {
      return [
         //About
         {
            wrappers: ['connectSection'],
            props: { htmlClass: 'section', title: 'About the Joint Applicant' },
            fieldGroup: [
               {
                  wrappers: ['section'],
                  props: { htmlClass: 'row' },
                  fieldGroup: [
                     {
                        wrappers: ['section'],
                        props: { htmlClass: 'col-sm-6' },
                        fieldGroup: [
                           {
                              key: 'relationshipType',
                              type: 'select',
                              props: {
                                 title: 'Relationship to Lead Applicant',
                                 required: true,
                                 options: this.dataService.getReferenceDataByName(this.referenceData, 'cn_relationshiptype'),
                              },
                           },
                        ],
                     },
                  ],
               },
               {
                  wrappers: ['section'],
                  props: { htmlClass: 'row' },
                  fieldGroup: [
                     {
                        wrappers: ['section'],
                        props: { htmlClass: 'col-sm-6' },
                        fieldGroup: [
                           {
                              key: 'title',
                              type: 'select',
                              props: {
                                 title: 'Title',
                                 required: true,
                                 options: this.dataService.getReferenceDataByName(this.referenceData, 'cn_titletype'),
                              },
                           },
                        ],
                     },
                     {
                        wrappers: ['section'],
                        props: { htmlClass: 'col-sm-6' },
                        fieldGroup: [
                           {
                              key: 'firstName',
                              type: 'input',
                              props: {
                                 title: 'First Name',
                                 required: true,
                                 minLength: 0,
                                 maxLength: 35,
                                 pattern: regEx.namePattern,
                              },
                              validation: {
                                 messages: {
                                    pattern: validationMsgs.alphaOnly,
                                 },
                              },
                           },
                        ],
                     },
                  ],
               },
               {
                  wrappers: ['section'],
                  props: { htmlClass: 'row' },
                  fieldGroup: [
                     {
                        wrappers: ['section'],
                        props: { htmlClass: 'col-sm-6' },
                        fieldGroup: [
                           {
                              key: 'middleName',
                              type: 'input',
                              props: {
                                 title: 'Middle Name',
                                 maxLength: 50,
                                 pattern: regEx.namePattern,
                              },
                              validation: {
                                 messages: {
                                    pattern: validationMsgs.alphaOnly,
                                 },
                              },
                           },
                        ],
                     },
                     {
                        wrappers: ['section'],
                        props: { htmlClass: 'col-sm-6' },
                        fieldGroup: [
                           {
                              key: 'lastName',
                              type: 'input',
                              props: {
                                 title: 'Last Name',
                                 required: true,
                                 maxLength: 35,
                                 pattern: regEx.namePattern,
                              },
                              validation: {
                                 messages: {
                                    pattern: validationMsgs.alphaOnly,
                                 },
                              },
                           },
                        ],
                     },
                  ],
               },
            ],
         },
         //Previous names
         {
            wrappers: ['connectSection'],
            props: { htmlClass: 'section', title: 'Previous names', subtitle: 'Enter any first or last names previously known as, e.g. Maiden name' },
            fieldGroup: [
               {
                  wrappers: ['section'],
                  props: { htmlClass: 'row' },
                  fieldGroup: [
                     {
                        wrappers: ['section'],
                        props: { htmlClass: 'col-sm-6' },
                        fieldGroup: [
                           {
                              expressions: {
                                 hide: (field: FormlyFieldConfig) =>
                                    field.model.previousLastName || field.model.previousMiddleName || field.model.previousFirstName,
                              },
                              key: 'previousTitle',
                              type: 'select',
                              props: {
                                 title: 'Title',
                                 options: this.dataService.getReferenceDataByName(this.referenceData, 'cn_titletype'),
                              },
                           },
                           {
                              expressions: {
                                 hide: (field: FormlyFieldConfig) =>
                                    !(field.model.previousLastName || field.model.previousMiddleName || field.model.previousFirstName),
                              },
                              key: 'previousTitle',
                              type: 'select',
                              props: {
                                 title: 'Title',
                                 required: true,
                                 options: this.dataService.getReferenceDataByName(this.referenceData, 'cn_titletype'),
                              },
                           },
                        ],
                     },
                     {
                        wrappers: ['section'],
                        props: { htmlClass: 'col-sm-6' },
                        fieldGroup: [
                           {
                              expressions: {
                                 hide: (field: FormlyFieldConfig) =>
                                    field.model.previousTitle || field.model.previousLastName || field.model.previousMiddleName,
                              },
                              key: 'previousFirstName',
                              type: 'input',
                              props: {
                                 title: 'First Name',
                                 maxLength: 35,
                                 pattern: regEx.namePattern,
                              },
                              validation: {
                                 messages: {
                                    pattern: validationMsgs.alphaOnly,
                                 },
                              },
                           },
                           {
                              expressions: {
                                 hide: (field: FormlyFieldConfig) =>
                                    !(field.model.previousTitle || field.model.previousLastName || field.model.previousMiddleName),
                              },
                              key: 'previousFirstName',
                              type: 'input',
                              props: {
                                 title: 'First Name',
                                 maxLength: 35,
                                 pattern: regEx.namePattern,
                                 required: true,
                              },
                              validation: {
                                 messages: {
                                    pattern: validationMsgs.alphaOnly,
                                 },
                              },
                           },
                        ],
                     },
                  ],
               },
               {
                  wrappers: ['section'],
                  props: { htmlClass: 'row' },
                  fieldGroup: [
                     {
                        wrappers: ['section'],
                        props: { htmlClass: 'col-sm-6' },
                        fieldGroup: [
                           {
                              key: 'previousMiddleName',
                              type: 'input',
                              props: {
                                 title: 'Middle Name',
                                 maxLength: 50,
                                 pattern: regEx.namePattern,
                              },
                              validation: {
                                 messages: {
                                    pattern: validationMsgs.alphaOnly,
                                 },
                              },
                           },
                        ],
                     },
                     {
                        wrappers: ['section'],
                        props: { htmlClass: 'col-sm-6' },
                        fieldGroup: [
                           {
                              expressions: {
                                 hide: (field: FormlyFieldConfig) =>
                                    field.model.previousTitle || field.model.previousMiddleName || field.model.previousFirstName,
                              },
                              key: 'previousLastName',
                              type: 'input',
                              props: {
                                 title: 'Last Name',
                                 maxLength: 35,
                                 pattern: regEx.namePattern,
                              },
                              validation: {
                                 messages: {
                                    pattern: validationMsgs.alphaOnly,
                                 },
                              },
                           },
                           {
                              expressions: {
                                 hide: (field: FormlyFieldConfig) =>
                                    !(field.model.previousTitle || field.model.previousMiddleName || field.model.previousFirstName),
                              },
                              key: 'previousLastName',
                              type: 'input',
                              props: {
                                 title: 'Last Name',
                                 maxLength: 35,
                                 pattern: regEx.namePattern,
                                 required: true,
                              },
                              validation: {
                                 messages: {
                                    pattern: validationMsgs.alphaOnly,
                                 },
                              },
                           },
                        ],
                     },
                  ],
               },
            ],
         },
         //Phone numbers & Email
         {
            wrappers: ['connectSection'],
            props: { htmlClass: 'section' },
            fieldGroup: [
               {
                  wrappers: ['section'],
                  props: { htmlClass: 'row' },
                  fieldGroup: [
                     {
                        wrappers: ['section'],
                        props: { htmlClass: 'col-sm-6' },
                        fieldGroup: [
                           {
                              key: 'mobilePhoneNumber',
                              type: 'input',
                              props: {
                                 title: 'Mobile Phone Number',
                                 maxLength: 15,
                                 pattern: regEx.mobilePattern,
                              },
                              validation: {
                                 messages: {
                                    pattern: validationMsgs.phone,
                                 },
                              },
                           },
                        ],
                     },
                     {
                        wrappers: ['section'],
                        props: { htmlClass: 'col-sm-6' },
                        fieldGroup: [
                           {
                              key: 'otherPhoneNumber',
                              type: 'input',
                              props: {
                                 title: 'Other Phone Number',
                                 maxLength: 15,
                                 pattern: regEx.mobilePattern,
                              },
                              validation: {
                                 messages: {
                                    pattern: validationMsgs.phone,
                                 },
                              },
                           },
                        ],
                     },
                     {
                        wrappers: ['section'],
                        props: { htmlClass: 'col-sm-12' },
                        fieldGroup: [
                           {
                              validators: {
                                 emailPatternCheck: {
                                    expression: (c: AbstractControl) => {
                                       return globalValidators['emailPatternCheck'](c);
                                    },
                                    title: 'Email Address',
                                    msg: validationMsgs.email,
                                 },
                                 emailSameCheck: {
                                    expression: (c: AbstractControl, f: FormlyFieldConfig) => {
                                       // const lead = this.afs.getLeadModel();
                                       const lead = {
                                          emailAddress: 'paragpatel3@gmail.com',
                                       };
                                       return globalValidators['emailSameCheck'](c, f, lead);
                                    },
                                    title: 'Email Address',
                                    msg: validationMsgs.emailSame,
                                 },
                              },
                              key: 'emailAddress',
                              type: 'input',
                              props: {
                                 title: 'Email Address',
                                 required: true,
                                 maxLength: 100,
                                 minLength: 1,
                              },
                              validation: {
                                 messages: {
                                    emailPatternCheck: validationMsgs.email,
                                    emailSameCheck: validationMsgs.emailSame,
                                 },
                              },
                              modelOptions: {
                                 updateOn: 'blur',
                              },
                           },
                        ],
                     },
                  ],
               },
            ],
         },
         //Probity
         {
            wrappers: ['connectSection'],
            props: { htmlClass: 'section' },
            fieldGroup: [
               {
                  wrappers: ['section'],
                  props: { htmlClass: 'row' },
                  fieldGroup: [
                     {
                        wrappers: ['section'],
                        props: { htmlClass: 'col-sm-12' },
                        fieldGroup: [
                           {
                              key: 'isAssociated',
                              type: 'radiobuttons',
                              props: {
                                 options: this.yesNoMap,
                                 labelHtmlClass: 'control-label',
                                 activeClass: 'active',
                                 required: true,
                                 title: 'Are you or any of your friends or family an employee or board member of Your Housing Group?',
                              },
                           },
                        ],
                     },
                  ],
               },
               {
                  wrappers: ['section'],
                  props: { htmlClass: 'row' },
                  fieldGroup: [
                     {
                        wrappers: ['section'],
                        props: { htmlClass: 'col-sm-6' },
                        fieldGroup: [
                           {
                              expressions: {
                                 hide: '!model.isAssociated ',
                              },
                              key: 'probityConnectionTypeId',
                              type: 'select',
                              props: {
                                 title: 'What is the nature of that connection?',
                                 required: true,
                                 options: this.dataService.getReferenceDataByName(this.referenceData, 'cn_probityconnectiontype'),
                              },
                           },
                        ],
                     },
                  ],
               },
               {
                  expressions: {
                     hide: (field: FormlyFieldConfig) => !(field.model.probityConnectionTypeId === appSettings.probityConnectionTypeToEmployee),
                  },
                  wrappers: ['section'],
                  props: { htmlClass: 'row' },
                  fieldGroup: [
                     {
                        wrappers: ['section'],
                        props: { htmlClass: 'col-sm-6' },
                        fieldGroup: [
                           {
                              key: 'probityTitle',
                              type: 'select',
                              props: {
                                 title: 'Employee Title',
                                 required: true,
                                 options: this.dataService.getReferenceDataByName(this.referenceData, 'cn_titletype'),
                              },
                           },
                           {
                              key: 'probityFirstName',
                              type: 'input',
                              props: {
                                 title: 'Employee First Name',
                                 required: true,
                                 maxLength: 35,
                                 pattern: regEx.namePattern,
                              },
                              validation: {
                                 messages: {
                                    pattern: validationMsgs.alphaOnly,
                                 },
                              },
                           },
                           {
                              key: 'probityLastName',
                              type: 'input',
                              props: {
                                 title: 'Employee Last Name',
                                 required: true,
                                 maxLength: 35,
                                 pattern: regEx.namePattern,
                              },
                              validation: {
                                 messages: {
                                    pattern: validationMsgs.alphaOnly,
                                 },
                              },
                           },
                        ],
                     },
                     {
                        wrappers: ['section'],
                        props: { htmlClass: 'col-sm-6' },
                        fieldGroup: [
                           {
                              key: 'probityRelationship',
                              type: 'input',
                              props: {
                                 title: 'Relationship',
                                 required: true,
                                 maxLength: 50,
                                 pattern: regEx.alphaPattern,
                              },
                              validation: {
                                 messages: {
                                    pattern: validationMsgs.alphaOnly,
                                 },
                              },
                           },
                           {
                              key: 'probityEmployeeRole',
                              type: 'input',
                              props: {
                                 title: 'Employee Role',
                                 required: true,
                              },
                           },
                        ],
                     },
                  ],
               },
               {
                  expressions: {
                     hide: (field: FormlyFieldConfig) => !(field.model.probityConnectionTypeId === appSettings.probityConnectionTypeToBoardMember),
                  },
                  wrappers: ['section'],
                  props: { htmlClass: 'row' },
                  fieldGroup: [
                     {
                        wrappers: ['section'],
                        props: { htmlClass: 'col-sm-6' },
                        fieldGroup: [
                           {
                              key: 'probityTitle',
                              type: 'select',
                              props: {
                                 title: 'Board Member Title',
                                 required: true,
                                 options: this.dataService.getReferenceDataByName(this.referenceData, 'cn_titletype'),
                              },
                           },
                           {
                              key: 'probityFirstName',
                              type: 'input',
                              props: {
                                 title: 'Board Member First Name',
                                 required: true,
                                 maxLength: 35,
                                 pattern: regEx.namePattern,
                              },
                              validation: {
                                 messages: {
                                    pattern: validationMsgs.alphaOnly,
                                 },
                              },
                           },
                           {
                              key: 'probityLastName',
                              type: 'input',
                              props: {
                                 title: 'Board Member Last Name',
                                 required: true,
                                 maxLength: 35,
                                 pattern: regEx.namePattern,
                              },
                              validation: {
                                 messages: {
                                    pattern: validationMsgs.alphaOnly,
                                 },
                              },
                           },
                        ],
                     },
                     {
                        wrappers: ['section'],
                        props: { htmlClass: 'col-sm-6' },
                        fieldGroup: [
                           {
                              key: 'probityRelationship',
                              type: 'input',
                              props: {
                                 title: 'Relationship',
                                 required: true,
                                 maxLength: 50,
                                 pattern: regEx.alphaPattern,
                              },
                              validation: {
                                 messages: {
                                    pattern: validationMsgs.alphaOnly,
                                 },
                              },
                           },
                           {
                              key: 'probityPositionOnBoard',
                              type: 'input',
                              props: {
                                 title: 'Board Member Position',
                                 required: true,
                                 maxLength: 50,
                                 pattern: regEx.alphaPattern,
                              },
                              validation: {
                                 messages: {
                                    pattern: validationMsgs.alphaOnly,
                                 },
                              },
                           },
                        ],
                     },
                  ],
               },
               {
                  expressions: {
                     hide: (field: FormlyFieldConfig) => !(field.model.probityConnectionTypeId === appSettings.probityConnectionTypeBoardMember),
                  },
                  wrappers: ['section'],
                  props: { htmlClass: 'row' },
                  fieldGroup: [
                     {
                        wrappers: ['section'],
                        props: { htmlClass: 'col-sm-6' },
                        fieldGroup: [
                           {
                              key: 'probityPositionOnBoard',
                              type: 'input',
                              props: {
                                 title: 'Position on Board',
                                 required: true,
                                 maxLength: 50,
                                 pattern: regEx.alphaPattern,
                              },
                              validation: {
                                 messages: {
                                    pattern: validationMsgs.alphaOnly,
                                 },
                              },
                           },
                        ],
                     },
                  ],
               },
               {
                  expressions: {
                     hide: (field: FormlyFieldConfig) => !(field.model.probityConnectionTypeId === appSettings.probityConnectionTypeEmployee),
                  },
                  wrappers: ['section'],
                  props: { htmlClass: 'row' },
                  fieldGroup: [
                     {
                        wrappers: ['section'],
                        props: { htmlClass: 'col-sm-6' },
                        fieldGroup: [
                           {
                              key: 'probityJobTitle',
                              type: 'input',
                              props: {
                                 title: 'Job Title',
                                 required: true,
                                 maxLength: 50,
                                 pattern: regEx.alphaPattern,
                              },
                              validation: {
                                 messages: {
                                    pattern: validationMsgs.alphaOnly,
                                 },
                              },
                           },
                        ],
                     },
                  ],
               },
            ],
         },
         // NI, Nationality, Gender, DOB
         {
            wrappers: ['connectSection'],
            props: { htmlClass: 'section' },
            fieldGroup: [
               {
                  wrappers: ['section'],
                  props: { htmlClass: 'row' },
                  fieldGroup: [
                     {
                        wrappers: ['section'],
                        props: { htmlClass: 'col-sm-6' },
                        fieldGroup: [
                           {
                              key: 'niNo',
                              type: 'input',
                              props: {
                                 supportingText: '(this should be entered in the format XX000000X) ',
                                 title: 'National Insurance Number',
                                 required: true,
                                 pattern: regEx.nationalInsuranceNumberPattern,
                              },
                              validation: {
                                 messages: {
                                    pattern: validationMsgs.niNumber,
                                 },
                              },
                              asyncValidators: {
                                 niNumber: {
                                    expression: (control: AbstractControl) => {
                                       //workaround to prevent reactive form conditionals triggering ni validation
                                       //the async validator becomes guarded against and runs 1 step behind the change cycle
                                       if (this.cachedNiNumber === control.value) {
                                          return of(true);
                                       } else {
                                          this.setCachedNiNumber(control.value);
                                       }

                                       const jointApplicant: any = this.afs.getJointModel();
                                       const contactid: any = jointApplicant.contact;
                                       const email: any = jointApplicant.jointApplicantEmail;

                                       return this.afds.getNationalInsuranceNumber(control.value, contactid, email).pipe(
                                          delay(500),
                                          map((res) => {
                                             if (res.status === 409) {
                                                return false;
                                             }

                                             return true;
                                          })
                                       );
                                    },
                                    message: 'National Insurance number already exists please contact the Lettings Team',
                                 },
                              },
                              parsers: [
                                 (value: any) => {
                                    return value?.toUpperCase();
                                 },
                              ],
                              modelOptions: {
                                 updateOn: 'blur',
                              },
                           },
                        ],
                     },
                     {
                        wrappers: ['section'],
                        props: { htmlClass: 'col-sm-6' },
                        fieldGroup: [
                           {
                              key: 'nationality',
                              type: 'select',
                              props: {
                                 title: 'Nationality',
                                 required: true,
                                 options: this.dataService.getReferenceDataByName(this.referenceData, 'vw_nationalitytype_shortlist'),
                              },
                           },
                        ],
                     },
                     {
                        wrappers: ['section'],
                        props: { htmlClass: 'col-sm-12' },
                        fieldGroup: [
                           {
                              key: 'gender',
                              type: 'radiobuttons',
                              props: {
                                 options: this.dataService.getReferenceDataByName(this.referenceData, 'cn_gendertype'),
                                 labelHtmlClass: 'control-label',
                                 activeClass: 'active',
                                 required: true,
                                 title: 'Gender',
                              },
                           },
                        ],
                     },
                     {
                        wrappers: ['section'],
                        props: { htmlClass: 'col-sm-6' },
                        fieldGroup: [
                           {
                              key: 'dateOfBirth',
                              type: 'datepicker',
                              props: {
                                 title: 'Date of Birth',
                                 supportingText: 'dd/mm/yyyy',
                                 minAge: 18,
                                 maxAge: 120,
                                 required: true,
                              },
                           },
                        ],
                     },
                  ],
               },
            ],
         },
         // Current Address
         {
            validators: {
               // we can use any key here; using a known key that error summary can pick up
               previousAddresses: {
                  expression: (c: AbstractControl, f: FormlyFieldConfig) => globalValidators['jointApplicantLengthOfTimeAtProperty'](c, f),
                  title: 'Address history',
                  msg: 'Please provide further address history',
               },
            },
            wrappers: ['connectSection'],
            props: { htmlClass: 'section', title: 'Current Address' },
            fieldGroup: [
               {
                  wrappers: ['section'],
                  props: { htmlClass: 'row' },
                  fieldGroup: [
                     {
                        wrappers: ['section'],
                        props: { htmlClass: 'col-sm-6' },
                        fieldGroup: [
                           {
                              key: 'isTheAddressTheSame',
                              type: 'radiobuttons',
                              props: {
                                 change: (fieldConfig: FormlyFieldConfig) => {
                                    changeFns['addressSameChange'](fieldConfig.formControl?.value);
                                 },
                                 options: this.yesNoMap,
                                 labelHtmlClass: 'control-label',
                                 activeClass: 'active',
                                 required: true,
                                 title: 'Is your address the same as the lead applicant?',
                              },
                           },
                        ],
                     },
                  ],
               },
               {
                  expressions: {
                     hide: (field: FormlyFieldConfig) => field.model.isTheAddressTheSame !== false,
                  },
                  wrappers: ['section'],
                  props: { htmlClass: 'row' },
                  fieldGroup: [
                     {
                        wrappers: ['section'],
                        props: { htmlClass: 'col-sm-6' },
                        fieldGroup: [
                           {
                              key: 'addressLine1',
                              type: 'input',
                              props: {
                                 title: 'House name or number',
                                 required: true,
                                 maxLength: 40,
                                 pattern: regEx.alphaNumericPattern,
                              },
                              validation: {
                                 messages: {
                                    pattern: validationMsgs.alphaNumeric,
                                 },
                              },
                           },
                           {
                              key: 'addressLine2',
                              type: 'input',
                              props: {
                                 title: 'Street',
                                 maxLength: 40,
                                 pattern: regEx.addressPattern,
                              },
                              validation: {
                                 messages: {
                                    pattern: validationMsgs.alphaNumeric,
                                 },
                              },
                           },
                           {
                              key: 'addressLine3',
                              type: 'input',
                              props: {
                                 title: 'Address Line 3',
                                 maxLength: 40,
                                 pattern: regEx.addressPattern,
                              },
                              validation: {
                                 messages: {
                                    pattern: validationMsgs.alphaNumeric,
                                 },
                              },
                           },
                           {
                              key: 'city',
                              type: 'input',
                              props: {
                                 title: 'City',
                                 maxLength: 40,
                                 pattern: regEx.alphaPattern,
                              },
                              validation: {
                                 messages: {
                                    pattern: validationMsgs.alphaOnly,
                                 },
                              },
                           },
                        ],
                     },
                     {
                        wrappers: ['section'],
                        props: { htmlClass: 'col-sm-6' },
                        fieldGroup: [
                           {
                              key: 'county',
                              type: 'input',
                              props: {
                                 title: 'County',
                                 maxLength: 40,
                                 pattern: regEx.alphaPattern,
                              },
                              validation: {
                                 messages: {
                                    pattern: validationMsgs.alphaOnly,
                                 },
                              },
                           },
                           {
                              key: 'country',
                              type: 'input',
                              props: {
                                 title: 'Country',
                                 maxLength: 80,
                                 pattern: regEx.countryPattern,
                              },
                              validation: {
                                 messages: {
                                    pattern: validationMsgs.alphaOnly,
                                 },
                              },
                           },
                           {
                              key: 'postCode',
                              type: 'input',
                              props: {
                                 title: 'Postcode',
                                 required: true,
                                 maxLength: 8,
                                 pattern: regEx.postCodePattern,
                              },
                              validation: {
                                 messages: {
                                    pattern: validationMsgs.postcode,
                                 },
                              },
                              parsers: [
                                 (value: any) => {
                                    return value?.toUpperCase();
                                 },
                              ],
                              modelOptions: {
                                 updateOn: 'blur',
                              },
                           },
                           {
                              key: 'durationAtCurrentProperty',
                              type: 'duration',
                              props: {
                                 title: 'How long have you lived at the property?',
                                 required: true,
                              },
                           },
                        ],
                     },
                  ],
               },
            ],
         },
         // Previous Addresses
         {
            wrappers: ['connectSection'],
            props: { htmlClass: 'section' },
            expressions: {
               hide: (field: FormlyFieldConfig) => !(field.model.isTheAddressTheSame != null && field.model.durationAtCurrentProperty < 60),
            },
            fieldGroup: [
               {
                  wrappers: ['section'],
                  fieldGroup: [
                     {
                        wrappers: ['section'],
                        props: { htmlClass: 'row' },
                        fieldGroup: [
                           {
                              key: 'previousAddresses',
                              defaultValue: [null],
                              type: 'array',
                              props: {
                                 add: 'Add a new address',
                                 itemTitle: 'Previous Address',
                                 style: {
                                    add: 'btn-success',
                                 },
                                 validationMessage: 'Please provide further address history',
                              },
                              fieldArray: {
                                 fieldGroup: [
                                    {
                                       wrappers: ['section'],
                                       fieldGroup: [
                                          {
                                             wrappers: ['section'],
                                             fieldGroup: [
                                                {
                                                   wrappers: ['section'],
                                                   props: { htmlClass: 'col-sm-6' },
                                                   fieldGroup: [
                                                      {
                                                         key: 'addressLine1',
                                                         type: 'input',
                                                         props: {
                                                            title: 'Address Line 1',
                                                            required: true,
                                                            maxLength: 40,
                                                            pattern: regEx.alphaNumericPattern,
                                                         },
                                                         validation: {
                                                            messages: {
                                                               pattern: validationMsgs.alphaNumeric,
                                                            },
                                                         },
                                                      },
                                                      {
                                                         key: 'addressLine2',
                                                         type: 'input',
                                                         props: {
                                                            title: 'Address Line 2',
                                                            maxLength: 40,
                                                            pattern: regEx.addressPattern,
                                                         },
                                                         validation: {
                                                            messages: {
                                                               pattern: validationMsgs.alphaNumeric,
                                                            },
                                                         },
                                                      },
                                                      {
                                                         key: 'addressLine3',
                                                         type: 'input',
                                                         props: {
                                                            title: 'Address Line 3',
                                                            maxLength: 40,
                                                            pattern: regEx.addressPattern,
                                                         },
                                                         validation: {
                                                            messages: {
                                                               pattern: validationMsgs.alphaNumeric,
                                                            },
                                                         },
                                                      },
                                                      {
                                                         key: 'city',
                                                         type: 'input',
                                                         props: {
                                                            title: 'City',
                                                            maxLength: 40,
                                                            pattern: regEx.alphaPattern,
                                                         },
                                                         validation: {
                                                            messages: {
                                                               pattern: validationMsgs.alphaOnly,
                                                            },
                                                         },
                                                      },
                                                   ],
                                                },
                                                {
                                                   wrappers: ['section'],
                                                   props: { htmlClass: 'col-sm-6' },
                                                   fieldGroup: [
                                                      {
                                                         key: 'county',
                                                         type: 'input',
                                                         props: {
                                                            title: 'County',
                                                            maxLength: 40,
                                                            pattern: regEx.alphaPattern,
                                                         },
                                                         validation: {
                                                            messages: {
                                                               pattern: validationMsgs.alphaOnly,
                                                            },
                                                         },
                                                      },
                                                      {
                                                         key: 'country',
                                                         type: 'input',
                                                         props: {
                                                            title: 'Country',
                                                            maxLength: 80,
                                                            pattern: regEx.countryPattern,
                                                         },
                                                         validation: {
                                                            messages: {
                                                               pattern: validationMsgs.alphaOnly,
                                                            },
                                                         },
                                                      },
                                                      {
                                                         key: 'postCode',
                                                         type: 'input',
                                                         props: {
                                                            title: 'Postcode',
                                                            required: true,
                                                            maxLength: 8,
                                                            pattern: regEx.postCodePattern,
                                                         },
                                                         validation: {
                                                            messages: {
                                                               pattern: validationMsgs.postcode,
                                                            },
                                                         },
                                                         parsers: [
                                                            (value: any) => {
                                                               return (value = value.toUpperCase());
                                                            },
                                                         ],
                                                      },
                                                      {
                                                         key: 'durationAtPreviousProperty',
                                                         type: 'duration',
                                                         props: {
                                                            title: 'How long have you lived at the previous property?',
                                                            required: true,
                                                         },
                                                      },
                                                   ],
                                                },
                                             ],
                                          },
                                       ],
                                    },
                                 ],
                              },
                           },
                        ],
                     },
                  ],
               },
            ],
         },
         // Living Arrangements
         {
            wrappers: ['connectSection'],
            props: { htmlClass: 'section', title: 'Living Arrangements' },
            fieldGroup: [
               {
                  wrappers: ['section'],
                  props: { htmlClass: 'row' },
                  fieldGroup: [
                     {
                        wrappers: ['section'],
                        props: { htmlClass: 'col-sm-12' },
                        fieldGroup: [
                           {
                              key: 'isCouncilHelping',
                              type: 'radiobuttons',
                              props: {
                                 options: this.yesNoMap,
                                 labelHtmlClass: 'control-label',
                                 activeClass: 'active',
                                 required: true,
                                 title: 'Are the council currently looking for somewhere for you to live?',
                              },
                           },
                        ],
                     },
                  ],
               },
            ],
         },
         // Contact Preferences (ops)
         {
            expressions: {
               hide: (field: FormlyFieldConfig) => !(field.model.applicationForm == 'ops'),
            },
            wrappers: ['connectSection'],
            props: { htmlClass: 'section', title: 'Contact Preferences' },
            fieldGroup: [
               {
                  wrappers: ['section'],
                  props: { htmlClass: 'row' },
                  fieldGroup: [
                     {
                        wrappers: ['section'],
                        props: { htmlClass: 'col-sm-12' },
                        fieldGroup: [
                           {
                              key: 'preferredContactMethod',
                              type: 'select',
                              props: {
                                 title: 'Preferred Method of Contact',
                                 required: true,
                                 options: this.dataService.getReferenceDataByName(this.referenceData, 'preferredcontactmethodcode'),
                              },
                           },
                           {
                              key: 'preferredLanguage',
                              type: 'select',
                              props: {
                                 title: 'Preferred language',
                                 required: true,
                                 options: this.dataService.getReferenceDataByName(this.referenceData, 'cn_language'),
                              },
                           },
                           {
                              expressions: {
                                 hide: (field: FormlyFieldConfig) => !(field.model.preferredLanguage == 875970001),
                              },
                              key: 'preferredLanguageOther',
                              type: 'input',
                              props: {
                                 title: 'Preferred language other',
                                 required: true,
                              },
                           },
                        ],
                     },
                  ],
               },
            ],
         },
         // Residency (ops)
         {
            expressions: {
               hide: (field: FormlyFieldConfig) => !(field.model.applicationForm == 'ops'),
            },
            wrappers: ['connectSection'],
            props: {
               htmlClass: 'section',
               title: 'Residency',
               subtitle:
                  'Before you can rent in England, you need to prove your right to rent to your landlord. How you prove your right to rent depends on your nationality and your immigration status. You will need to bring proof to the viewing. For further info see https://www.gov.uk/prove-right-to-rent  ',
            },
            fieldGroup: [
               {
                  wrappers: ['section'],
                  props: { htmlClass: 'row' },
                  fieldGroup: [
                     {
                        wrappers: ['section'],
                        props: { htmlClass: 'col-sm-6' },
                        fieldGroup: [
                           {
                              key: 'ukResident',
                              type: 'radiobuttons',
                              props: {
                                 options: this.yesNoMap,
                                 labelHtmlClass: 'control-label',
                                 activeClass: 'active',
                                 required: true,
                                 title: 'Are you a UK Resident?',
                              },
                           },
                           {
                              expressions: {
                                 hide: (field: FormlyFieldConfig) => field.model.ukResident !== false,
                              },
                              key: 'eligibleToRemainInTheUk',
                              type: 'radiobuttons',
                              props: {
                                 options: this.yesNoMap,
                                 labelHtmlClass: 'control-label',
                                 activeClass: 'active',
                                 required: true,
                                 title: 'Are you eligible to remain in the UK?',
                              },
                           },
                        ],
                     },
                     {
                        wrappers: ['section'],
                        props: { htmlClass: 'col-sm-6' },
                        fieldGroup: [
                           {
                              type: 'help',
                              props: {
                                 helpvalue: '<h3>Which of the following are you able to supply at the viewing?</h3>',
                              },
                           },
                           {
                              key: 'passport',
                              type: 'radiobuttons',
                              props: {
                                 title: 'Passport',
                                 required: true,
                                 labelHtmlClass: 'control-label',
                                 activeClass: 'active',
                                 options: this.yesNoMap,
                              },
                           },
                           {
                              key: 'drivingLicence',
                              type: 'radiobuttons',
                              props: {
                                 title: 'Driving Licence',
                                 required: true,
                                 labelHtmlClass: 'control-label',
                                 activeClass: 'active',
                                 options: this.yesNoMap,
                              },
                           },
                           {
                              key: 'biometricCard',
                              type: 'radiobuttons',
                              props: {
                                 title: 'Bio metric card',
                                 required: true,
                                 labelHtmlClass: 'control-label',
                                 activeClass: 'active',
                                 options: this.yesNoMap,
                              },
                           },
                           {
                              key: 'bankStatement',
                              type: 'radiobuttons',
                              props: {
                                 title: 'Bank Statement',
                                 required: true,
                                 labelHtmlClass: 'control-label',
                                 activeClass: 'active',
                                 options: this.yesNoMap,
                              },
                           },
                           {
                              key: 'rtrCode',
                              type: 'radiobuttons',
                              props: {
                                 title: 'Right To Rent Code',
                                 required: true,
                                 labelHtmlClass: 'control-label',
                                 activeClass: 'active',
                                 options: this.yesNoMap,
                                 description:
                                    'If you’re not a British or Irish citizen, you can usually get a share code to prove your right to rent. See https://www.gov.uk/prove-right-to-rent for more details.',
                              },
                           },
                           {
                              key: 'other',
                              type: 'radiobuttons',
                              props: {
                                 title: 'Other',
                                 required: true,
                                 labelHtmlClass: 'control-label',
                                 activeClass: 'active',
                                 options: this.yesNoMap,
                              },
                           },
                           {
                              expressions: {
                                 hide: '!model.other',
                              },
                              key: 'otherWhat',
                              type: 'input',
                              props: {
                                 required: true,
                                 title: 'Other What',
                              },
                           },
                        ],
                     },
                  ],
               },
            ],
         },
         //Employment Status
         {
            wrappers: ['connectSection'],
            props: { htmlClass: 'section', title: 'Employment Status' },
            fieldGroup: [
               {
                  wrappers: ['section'],
                  props: { htmlClass: 'row' },
                  fieldGroup: [
                     {
                        wrappers: ['section'],
                        props: { htmlClass: 'col-sm-12' },
                        fieldGroup: [
                           {
                              key: 'employmentSituationTypeId',
                              type: 'select',
                              props: {
                                 title: 'Which best describes your current employment status?',
                                 required: true,
                                 options: this.dataService.getReferenceDataByName(this.referenceData, 'cn_employmentsituationtype'),
                              },
                           },
                        ],
                     },
                  ],
               },
            ],
         },
         // Criminal Convictions (ops only)
         {
            expressions: {
               hide: (field: FormlyFieldConfig) => !(field.model.applicationForm == 'ops'),
            },
            wrappers: ['connectSection'],
            props: { htmlClass: 'section', title: 'Criminal Convictions' },
            fieldGroup: [
               {
                  key: 'hasCriminalConviction',
                  type: 'radiobuttons',
                  props: {
                     title: 'Does this applicant have unspent criminal convictions?',
                     required: true,
                     labelHtmlClass: 'control-label',
                     activeClass: 'active',
                     options: this.yesNoMap,
                  },
               },
               {
                  expressions: {
                     hide: (field: FormlyFieldConfig) => !field.model.hasCriminalConviction,
                  },
                  fieldGroup: [
                     {
		        wrappers: ['section'],
			fieldGroup: [                           
			   {
                              key: 'criminalConvictions',
                              defaultValue: [null],
                              type: 'array',
                              props: {
                                 add: 'Add More',
                                 itemTitle: 'Conviction',
                                 style: {
                                    add: 'btn-success',
                                 },
                                 // validationMessage: "",
                              },
                              fieldArray: {
                                 fieldGroup: [
                                    {
                                       wrappers: ['section'],
                                       props: { htmlClass: 'row' },
                                       fieldGroup: [
                                          //id?
                                          {
                                             wrappers: ['section'],
                                             props: { htmlClass: 'col-sm-6' },
                                             fieldGroup: [
                                                {
                                                   key: 'name',
                                                   type: 'input',
                                                   props: {
                                                      title: 'Name of Conviction',
                                                      required: true,
                                                   },
                                                },
                                             ],
                                          },
                                          {
                                             wrappers: ['section'],
                                             props: { htmlClass: 'col-sm-6' },
                                             fieldGroup: [
                                                {
                                                   key: 'sentenceDate',
                                                   type: 'datepicker',
                                                   props: {
                                                      title: 'Sentence Date',
                                                      required: true,
                                                      supportingText: 'dd/mm/yyyy',
                                                      minAge: 0,
                                                      maxAge: 120,
                                                   },
                                                },
                                             ],
                                          },
                                          {
                                             wrappers: ['section'],
                                             props: { htmlClass: 'col-sm-12' },
                                             fieldGroup: [
                                                {
                                                   key: 'details',
                                                   type: 'textarea',
                                                   props: {
                                                      required: true,
                                                      title: 'Please Provide Details of the Conviction.',
                                                   },
                                                },
                                             ],
                                          },
                                       ],
                                    },
                                 ],
                              },
                           },
                        ],
                     },
                  ],
               },
            ],
         },
      ];
   }
}
